function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EdgeService;
(function(EdgeService) {
    EdgeService["Monolith"] = "monolith";
    EdgeService["Cx"] = "cx";
})(EdgeService || (EdgeService = {}));
var _obj;
var PRODUCTION_URLS = (_obj = {}, _define_property(_obj, EdgeService.Monolith, "https://www.lemonade.com"), _define_property(_obj, EdgeService.Cx, "https://cx.lemonade.com"), _obj);

export { EdgeService, PRODUCTION_URLS };
